export default __webpack_public_path__ + "static/media/networking.2e0f2eb5.jpg";